import { Location } from '@angular/common';
import { Component, inject } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ButtonModule } from 'primeng/button';
import { ComponentAccess } from '../../../../../common/decorators/component-access.decorator';
import { CommonRoute } from '../../../../../common/enums/common-route.enum';
import { AuthenticationService } from '../../../../../common/services/authentication/authentication.service';
import { ReturnUrlService } from '../../../../../common/services/return-url/return-url.service';
import { LayoutService } from '../../../../layout/service/app.layout.service';

@Component({
  selector: 'app-access-denied',
  standalone: true,
  imports: [ButtonModule],
  templateUrl: './access-denied.component.html',
  styleUrl: './access-denied.component.scss',
})
@ComponentAccess('AccessDeniedComponent')
export class AccessDeniedComponent {
  readonly layoutService = inject(LayoutService);
  private readonly router = inject(Router);
  private readonly route = inject(ActivatedRoute);
  private readonly location = inject(Location);
  private returnUrlService = inject(ReturnUrlService);
  private authenticationService = inject(AuthenticationService);

  requestedUrl: string | null = null;

  constructor() {
    // Get the returnUrl from query params (set by the guard)
    this.requestedUrl = this.route.snapshot.queryParamMap.get('returnUrl');
  }

  logout() {
    this.router.navigate([CommonRoute.LOGOUT]);
  }

  goBack() {
    const win = window;

    if (win && win.history.length > 1) {
      this.authenticationService.logout();
      this.location.back();
    } else {
      // If there's no history, fallback to login with returnUrl
      this.router.navigate([CommonRoute.LOGIN], {
        queryParams: {
          returnUrl: this.returnUrlService.getSanitizedReturnUrl(
            this.requestedUrl ?? CommonRoute.HOME,
          ),
        },
      });
    }
  }
}
